import { useCustomerAreas } from 'services/assist-api/entities/customers-areas/customers-areas';
import type { CustomerAreaWithMarkingEnabled } from 'services/assist-api/entities/customers-areas/types';
import { useAuthCustomer } from 'services/providers/auth.hooks';
import { useAuth } from 'services/providers/auth.provider';
import { isInitialLoad } from 'utils/check-query-status';

export default function useMarkingAccess(): {
  belongsToMarkingOrganisation: boolean;
  isMarkingAccessLoading: boolean;
} {
  const { isLoading: isAuthLoading } = useAuth();
  const currentOrganisation = useAuthCustomer();

  // Fetch all areas that the user is subscribed that have marking enabled. This could be expanded
  // to authorise other pages based on current subscriptions or other rules.
  // Note: the customer areas should always be fetched and authorised, regardless of whether the
  // user is currently logged into a customer.
  const organisationAreasQuery = useCustomerAreas<CustomerAreaWithMarkingEnabled>(
    {
      filters: {
        customer: currentOrganisation?.id,
        'area.markingEnabled': true
      },
      groups: ['area-markingenabled'],
      include: 'area'
    },
    { enabled: !isAuthLoading }
  );
  const markingEnabledOrganisationAreas = organisationAreasQuery.data?.json || [];

  return {
    belongsToMarkingOrganisation: markingEnabledOrganisationAreas.length > 0,
    isMarkingAccessLoading: isInitialLoad(organisationAreasQuery)
  };
}
